// extracted by mini-css-extract-plugin
export default {"container":"Admins_container__BJMg8","table_actions":"Admins_table_actions__H-0Ww"};